export enum POSSIBLE_METRICS_ENUM {
  PRICE = "price",
  MARKET_CAP_FULLY_DILUTED = "market_cap_fully_diluted",
  MARKET_CAP_CIRCULATING = "market_cap_circulating",
  TOKEN_TRADING_VOLUME = "token_trading_volume",
  TOKEN_TURNOVER_FULLY_DILUTED = "token_turnover_fully_diluted",
  TOKEN_TURNOVER_CIRCULATING = "token_turnover_circulating",
  TOKENHOLDERS = "tokenholders",
  TOKEN_SUPPLY_CIRCULATING = "token_supply_circulating",
  TOKEN_SUPPLY_MAXIMUM = "token_supply_maximum",
  NET_DEPOSITS = "net_deposits",
  BRIDGE_DEPOSITS = "bridge_deposits",
  TVL = "tvl",
  TRANSACTION_VOLUME = "transaction_volume",
  TRADING_VOLUME = "trading_volume",
  TRADEABLE_PAIRS = "tradeable_pairs",
  TRADEABLE_ASSETS = "tradeable_assets",
  TRANSFER_VOLUME = "transfer_volume",
  ASSETS_STAKED = "assets_staked",
  FLASH_LOAN_VOLUME = "flash_loan_volume",
  ACTIVE_LOANS = "active_loans",
  OUTSTANDING_SUPPLY = "outstanding_supply",
  CAPITAL_DEPLOYED = "capital_deployed",
  FEES = "fees",
  FEES_SUPPLY_SIDE = "fees_supply_side",
  REVENUE = "revenue",
  EXPENSES = "expenses",
  COST_OF_REVENUE = "cost_of_revenue",
  OPERATING_EXPENSES = "operating_expenses",
  TOKEN_INCENTIVES = "token_incentives",
  GROSS_PROFIT = "gross_profit",
  EARNINGS = "earnings",
  VOTING_INCENTIVES = "voting_incentives",
  PF_FULLY_DILUTED = "pf_fully_diluted",
  PF_CIRCULATING = "pf_circulating",
  PS_FULLY_DILUTED = "ps_fully_diluted",
  PS_CIRCULATING = "ps_circulating",
  LIQUIDITY_TURNOVER = "liquidity_turnover",
  TREASURY = "treasury",
  TREASURY_NET = "treasury_net",
  USER_DAU = "user_dau",
  USER_WAU = "user_wau",
  USER_MAU = "user_mau",
  ACTIVE_ADDRESSES_DAILY = "active_addresses_daily",
  ACTIVE_ADDRESSES_WEEKLY = "active_addresses_weekly",
  ACTIVE_ADDRESSES_MONTHLY = "active_addresses_monthly",
  ACTIVE_DEVELOPERS = "active_developers",
  CODE_COMMITS = "code_commits",
  CONTRACT_DEPLOYERS = "contract_deployers",
  TRADE_COUNT = "trade_count",
  TRANSACTION_COUNT = "transaction_count",
  TRANSACTIONS_PER_SECOND = "transactions_per_second",
  TRANSACTION_FEE_AVERAGE = "transaction_fee_average",
  TRANSACTION_FEE_MEDIAN = "transaction_fee_median",
  AFPU = "afpu",
  ARPU = "arpu",
  MESSAGE_COUNT = "message_count",
  TRADING_VOLUME_AVG_PER_TRADE_COUNT = "trading_volume_avg_per_trade_count",
  TRADING_VOLUME_AVG_PER_USER = "trading_volume_avg_per_user",
  BLOCK_TIME = "block_time",
  VESTING_SCHEDULE = "vesting_schedule",
  MESSAGE_EXECUTION_RATE = "message_execution_rate",
  TOTAL_ICP_STAKED_ON_NNS = "total_icp_staked_on_nns",
  NUMBER_OF_ICP_TRANSACTIONS = "number_of_icp_transactions",
  CKBTC_TOTAL_SUPPLY = "ckbtc_total_supply",
  TOTAL_ICP_BURNED = "total_icp_burned",
  NNS_PROPOSALS = "nns_proposals",
  TOTAL_TRANSACTION_FEES = "total_transaction_fees",
  NUMBER_OF_NEURONS = "number_of_neurons",
  TOTAL_INTERNET_IDENTITIES = "total_internet_identities",
  UNIQUE_TRANSACTING_WALLETS = "unique_transacting_wallets",
  BLOCKS_PER_SECOND = "blocks_per_second",
  CYCLES_BURN_RATE = "cycles_burn_rate",
  SUPERCHAIN_FEES = "superchain_fees",
  STABLECOIN_MINTS = "stablecoin_mints",
  STABLECOIN_REDEMPTIONS = "stablecoin_redemptions",
  NOTIONAL_TRADING_VOLUME = "notional_trading_volume",
}
export type POSSIBLE_METRICS = `${POSSIBLE_METRICS_ENUM}`

export enum POSSIBLE_METRICS_SLUG_ENUM {
  PRICE = "price",
  AVG_RELAYCHAIN_INCLUSION_TIME = "avg-relaychain-inclusion-time",
  MARKET_CAP_FULLY_DILUTED = "market-cap-fully-diluted",
  MARKET_CAP_CIRCULATING = "market-cap-circulating",
  TOKEN_TRADING_VOLUME = "token-trading-volume",
  TOKEN_TURNOVER_FULLY_DILUTED = "token-turnover-fully-diluted",
  TOKEN_TURNOVER_CIRCULATING = "token-turnover-circulating",
  TOKENHOLDERS = "tokenholders",
  TOKEN_SUPPLY_CIRCULATING = "token-supply-circulating",
  TOKEN_SUPPLY_MAXIMUM = "token-supply-maximum",
  NET_DEPOSITS = "net-deposits",
  BRIDGE_DEPOSITS = "bridge-deposits",
  TVL = "tvl",
  TRANSACTION_VOLUME = "transaction-volume",
  TRADING_VOLUME = "trading-volume",
  TRADEABLE_PAIRS = "tradeable-pairs",
  TRADEABLE_ASSETS = "tradeable-assets",
  TRANSFER_VOLUME = "transfer-volume",
  ASSETS_STAKED = "assets-staked",
  FLASH_LOAN_VOLUME = "flash-loan-volume",
  ACTIVE_LOANS = "active-loans",
  OUTSTANDING_SUPPLY = "outstanding-supply",
  CAPITAL_DEPLOYED = "capital-deployed",
  FEES = "fees",
  FEES_SUPPLY_SIDE = "fees-supply-side",
  REVENUE = "revenue",
  EXPENSES = "expenses",
  COST_OF_REVENUE = "cost-of-revenue",
  OPERATING_EXPENSES = "operating-expenses",
  TOKEN_INCENTIVES = "token-incentives",
  GROSS_PROFIT = "gross-profit",
  EARNINGS = "earnings",
  VOTING_INCENTIVES = "voting-incentives",
  PF_FULLY_DILUTED = "pf-fully-diluted",
  PF_CIRCULATING = "pf-circulating",
  PS_FULLY_DILUTED = "ps-fully-diluted",
  PS_CIRCULATING = "ps-circulating",
  LIQUIDITY_TURNOVER = "liquidity-turnover",
  TREASURY = "treasury",
  TREASURY_NET = "treasury-net",
  USER_DAU = "user-dau",
  USER_WAU = "user-wau",
  USER_MAU = "user-mau",
  ACTIVE_DEVELOPERS = "active-developers",
  CODE_COMMITS = "code-commits",
  CONTRACT_DEPLOYERS = "contract-deployers",
  TRADE_COUNT = "trade-count",
  TRANSACTION_COUNT = "transaction-count",
  TRANSACTIONS_PER_SECOND = "transactions-per-second",
  TRANSACTION_FEE_AVERAGE = "transaction-fee-average",
  AFPU = "afpu",
  ARPU = "arpu",
  MESSAGE_COUNT = "message-count",
  TRADING_VOLUME_AVG_PER_TRADE_COUNT = "trading-volume-avg-per-trade-count",
  TRADING_VOLUME_AVG_PER_USER = "trading-volume-avg-per-user",
  BLOCK_TIME = "block-time",
  VESTING_SCHEDULE = "vesting-schedule",
  MESSAGE_EXECUTION_RATE = "message-execution-rate",
  TOTAL_ICP_STAKED_ON_NNS = "total-icp-staked-on-nns",
  NUMBER_OF_ICP_TRANSACTIONS = "number-of-icp-transactions",
  CKBTC_TOTAL_SUPPLY = "ckbtc-total-supply",
  TOTAL_ICP_BURNED = "total-icp-burned",
  NNS_PROPOSALS = "nns-proposals",
  TOTAL_TRANSACTION_FEES = "total-transaction-fees",
  NUMBER_OF_NEURONS = "number-of-neurons",
  TOTAL_INTERNET_IDENTITIES = "total-internet-identities",
  UNIQUE_TRANSACTING_WALLETS = "unique-transacting-wallets",
  BLOCKS_PER_SECOND = "blocks-per-second",
  CYCLES_BURN_RATE = "cycles-burn-rate",
  SUPERCHAIN_FEES = "superchain-fees",
  STABLECOIN_MINTS = "stablecoin-mints",
  STABLECOIN_REDEMPTIONS = "stablecoin-redemptions",
  NOTIONAL_TRADING_VOLUME = "notional-trading-volume",
}
export type POSSIBLE_METRICS_SLUGS = `${POSSIBLE_METRICS_SLUG_ENUM}`

const metricConfiguration = [
  [
    "price",
    {
      categories: ["trading"],
      metric_id: "price",
      definition: "average USD value of the protocol’s governance token.",
      title: "Price",
      long_title: null,
      short_title: "Price",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 0,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko",
      tier: "pro",
      dashboard_enabled: false,
      slug: "price",
    },
  ],
  [
    "market_cap_fully_diluted",
    {
      categories: ["trading"],
      metric_id: "market_cap_fully_diluted",
      definition: "maximum supply * average price of governance token.",
      title: "Market cap (fully diluted)",
      long_title: null,
      short_title: "Fully diluted mc.",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 1000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko",
      tier: "free",
      dashboard_enabled: true,
      slug: "market-cap-fully-diluted",
    },
  ],
  [
    "market_cap_circulating",
    {
      categories: ["trading"],
      metric_id: "market_cap_circulating",
      definition: "circulating supply * average price of governance token.",
      title: "Market cap (circulating)",
      long_title: null,
      short_title: "Circulating mc.",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 2000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko",
      tier: "free",
      dashboard_enabled: true,
      slug: "market-cap-circulating",
    },
  ],
  [
    "token_trading_volume",
    {
      categories: ["trading"],
      metric_id: "token_trading_volume",
      definition: "trading volume of the protocol’s governance token.",
      title: "Token trading volume",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 3000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko",
      tier: "pro",
      dashboard_enabled: true,
      slug: "token-trading-volume",
    },
  ],
  [
    "token_turnover_fully_diluted",
    {
      categories: ["trading"],
      metric_id: "token_turnover_fully_diluted",
      definition:
        "average token trading volume divided by fully diluted market cap.",
      title: "Token turnover (fully diluted)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "percent",
      static: false,
      is_lower_value_better: false,
      index: 3250,
      trending: false,
      table_enabled: false,
      chart_enabled: false,
      is_gmv_metric: false,
      sources: "CoinGecko",
      tier: "pro",
      dashboard_enabled: false,
      slug: "token-turnover-fully-diluted",
    },
  ],
  [
    "token_turnover_circulating",
    {
      categories: ["trading"],
      metric_id: "token_turnover_circulating",
      definition:
        "average token trading volume divided by circulating market cap.",
      title: "Token turnover (circulating)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "percent",
      static: false,
      is_lower_value_better: false,
      index: 3500,
      trending: false,
      table_enabled: false,
      chart_enabled: false,
      is_gmv_metric: false,
      sources: "CoinGecko",
      tier: "pro",
      dashboard_enabled: false,
      slug: "token-turnover-circulating",
    },
  ],
  [
    "tokenholders",
    {
      categories: ["trading"],
      metric_id: "tokenholders",
      definition: "number of addresses with token balance greater than 0.",
      title: "Tokenholders",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 4000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "tokenholders",
    },
  ],
  [
    "token_supply_circulating",
    {
      categories: [],
      metric_id: "token_supply_circulating",
      definition:
        "the amount of governance tokens that are circulating in the market and thus freely tradable.",
      title: "Circulating supply",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 4250,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: false,
      slug: "token-supply-circulating",
    },
  ],
  [
    "token_supply_maximum",
    {
      categories: [],
      metric_id: "token_supply_maximum",
      definition:
        "the maximum amount of governance tokens that will ever exist.",
      title: "Maximum supply",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 4300,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "token-supply-maximum",
    },
  ],
  [
    "net_deposits",
    {
      categories: ["cash-flow"],
      metric_id: "net_deposits",
      definition: "total value deposited to the protocol.",
      title: "Net deposits",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 4500,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "net-deposits",
    },
  ],
  [
    "bridge_deposits",
    {
      categories: ["cash-flow"],
      metric_id: "bridge_deposits",
      definition: "total value deposited to the protocol’s bridging contracts.",
      title: "Bridge deposits",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 4750,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "bridge-deposits",
    },
  ],
  [
    "tvl",
    {
      categories: ["cash-flow"],
      metric_id: "tvl",
      definition:
        "average value of funds locked into the protocol’s smart contracts.",
      title: "Total value locked",
      long_title: "Total value locked (TVL)",
      short_title: "TVL",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 5000,
      trending: true,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "free",
      dashboard_enabled: true,
      slug: "tvl",
    },
  ],
  [
    "transaction_volume",
    {
      categories: ["cash-flow"],
      metric_id: "transaction_volume",
      definition: "total transaction volume on the protocol.",
      title: "Transaction volume",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 6000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "transaction-volume",
    },
  ],
  [
    "trading_volume",
    {
      categories: ["cash-flow"],
      metric_id: "trading_volume",
      definition: "total trading volume on the protocol.",
      title: "Trading volume",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 7000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "trading-volume",
    },
  ],
  [
    "tradeable_pairs",
    {
      categories: ["alternative"],
      metric_id: "tradeable_pairs",
      definition:
        "the number of unique trading pairs deployed by the project’s users. Composition shows how the liquidity is distributed across pairs.",
      title: "Tradeable pairs",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 7400,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "tradeable-pairs",
    },
  ],
  [
    "tradeable_assets",
    {
      categories: ["alternative"],
      metric_id: "tradeable_assets",
      definition:
        "the number of unique tokens available for trading in the project’s trading pairs. Composition shows how the liquidity is distributed across tokens.",
      title: "Tradeable assets",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 7500,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "tradeable-assets",
    },
  ],
  [
    "transfer_volume",
    {
      categories: ["trading"],
      metric_id: "transfer_volume",
      definition: "total bridging volume on the protocol.",
      title: "Transfer volume",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 8000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "transfer-volume",
    },
  ],
  [
    "assets_staked",
    {
      categories: [],
      metric_id: "assets_staked",
      definition: "average value of assets staked through the protocol.",
      title: "Assets staked",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 9000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "assets-staked",
    },
  ],
  [
    "flash_loan_volume",
    {
      categories: ["trading"],
      metric_id: "flash_loan_volume",
      definition:
        "the value of uncollateralized loans taken out of projects' smart contracts which are paid back within the same transaction (+ fee).",
      title: "Flash loan volume",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 10000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "flash-loan-volume",
    },
  ],
  [
    "active_loans",
    {
      categories: ["cash-flow"],
      metric_id: "active_loans",
      definition: "average value of outstanding borrows on the protocol.",
      title: "Active loans",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 10000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "active-loans",
    },
  ],
  [
    "outstanding_supply",
    {
      categories: [],
      metric_id: "outstanding_supply",
      definition:
        "average value of outstanding stablecoin supply on the protocol.",
      title: "Outstanding supply",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 11000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "outstanding-supply",
    },
  ],
  [
    "capital_deployed",
    {
      categories: [],
      metric_id: "capital_deployed",
      definition: "average value of capital deployed through the protocol.",
      title: "Capital deployed",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 12000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: true,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "capital-deployed",
    },
  ],
  [
    "fees",
    {
      categories: ["cash-flow"],
      metric_id: "fees",
      definition: "total fees paid by users.",
      title: "Fees",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 13000,
      trending: true,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "free",
      dashboard_enabled: true,
      slug: "fees",
    },
  ],
  [
    "fees_supply_side",
    {
      categories: ["cash-flow"],
      metric_id: "fees_supply_side",
      definition: "share of fees that goes to the service providers.",
      title: "Supply-side fees",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 14000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: false,
      slug: "fees-supply-side",
    },
  ],
  [
    "revenue",
    {
      categories: ["cash-flow"],
      metric_id: "revenue",
      definition: "share of fees that goes to the protocol.",
      title: "Revenue",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 15000,
      trending: true,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "revenue",
    },
  ],
  [
    "expenses",
    {
      categories: ["cash-flow"],
      metric_id: "expenses",
      definition: "total onchain expenses for the protocol. ",
      title: "Expenses",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 15500,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "expenses",
    },
  ],
  [
    "cost_of_revenue",
    {
      categories: ["cash-flow"],
      metric_id: "cost_of_revenue",
      definition: "total costs directly related to the revenue.",
      title: "Cost of revenue",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 15600,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "cost-of-revenue",
    },
  ],
  [
    "operating_expenses",
    {
      categories: ["cash-flow"],
      metric_id: "operating_expenses",
      definition:
        "Total onchain expenses for the protocol (excluding token incentives).",
      title: "Operating expenses",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 15700,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: false,
      slug: "operating-expenses",
    },
  ],
  [
    "token_incentives",
    {
      categories: ["cash-flow"],
      metric_id: "token_incentives",
      definition:
        "USD value of the protocol’s governance tokens that have been distributed to users.",
      title: "Token incentives",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 16000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "token-incentives",
    },
  ],
  [
    "gross_profit",
    {
      categories: ["cash-flow"],
      metric_id: "gross_profit",
      definition: "revenue minus cost of revenue.",
      title: "Gross profit",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 16500,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "gross-profit",
    },
  ],
  [
    "earnings",
    {
      categories: ["cash-flow"],
      metric_id: "earnings",
      definition: "revenue minus token incentives.",
      title: "Earnings",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 17000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "earnings",
    },
  ],
  [
    "voting_incentives",
    {
      categories: ["cash-flow"],
      metric_id: "voting_incentives",
      definition:
        "Voting rewards earned by vote-escrowed governance token holders for directing liquidity to selected pools.",
      title: "Voting incentives",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: false,
      is_lower_value_better: false,
      index: 17500,
      trending: false,
      table_enabled: false,
      chart_enabled: false,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "free",
      dashboard_enabled: false,
      slug: "voting-incentives",
    },
  ],
  [
    "pf_fully_diluted",
    {
      categories: ["valuation"],
      metric_id: "pf_fully_diluted",
      definition: "fully diluted market cap / annualized fees.",
      title: "P/F ratio (fully diluted)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "ratio",
      static: true,
      is_lower_value_better: true,
      index: 18000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko, Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "pf-fully-diluted",
    },
  ],
  [
    "pf_circulating",
    {
      categories: ["valuation"],
      metric_id: "pf_circulating",
      definition: "circulating market cap / annualized fees.",
      title: "P/F ratio (circulating)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "ratio",
      static: true,
      is_lower_value_better: true,
      index: 19000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko, Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "pf-circulating",
    },
  ],
  [
    "ps_fully_diluted",
    {
      categories: ["valuation"],
      metric_id: "ps_fully_diluted",
      definition: "fully diluted market cap / annualized revenue.",
      title: "P/S ratio (fully diluted)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "ratio",
      static: true,
      is_lower_value_better: true,
      index: 20000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko, Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "ps-fully-diluted",
    },
  ],
  [
    "ps_circulating",
    {
      categories: ["valuation"],
      metric_id: "ps_circulating",
      definition: "circulating market cap / annualized revenue.",
      title: "P/S ratio (circulating)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "ratio",
      static: true,
      is_lower_value_better: true,
      index: 21000,
      trending: true,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "CoinGecko, Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "ps-circulating",
    },
  ],
  [
    "liquidity_turnover",
    {
      categories: ["valuation"],
      metric_id: "liquidity_turnover",
      definition: "trading volume / total value locked.",
      title: "Liquidity turnover",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "ratio",
      static: true,
      is_lower_value_better: false,
      index: 21500,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "free",
      dashboard_enabled: true,
      slug: "liquidity-turnover",
    },
  ],
  [
    "treasury",
    {
      categories: ["cash-flow"],
      metric_id: "treasury",
      definition:
        "USD value of the protocol’s funds held on-chain (including unallocated governance tokens).",
      title: "Treasury",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 22000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "treasury",
    },
  ],
  [
    "treasury_net",
    {
      categories: ["cash-flow"],
      metric_id: "treasury_net",
      definition:
        "USD value of the protocol’s funds held on-chain (excluding unallocated governance tokens).",
      title: "Net treasury",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 22500,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "treasury-net",
    },
  ],
  [
    "user_dau",
    {
      categories: ["alternative"],
      metric_id: "user_dau",
      definition:
        "number of distinct addresses interacting with business relevant contracts on a daily basis.",
      title: "Active users (daily)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 23500,
      trending: true,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "free",
      dashboard_enabled: true,
      slug: "user-dau",
    },
  ],
  [
    "user_wau",
    {
      categories: ["alternative"],
      metric_id: "user_wau",
      definition:
        "number of distinct addresses interacting with business relevant contracts on a weekly basis, based on a 7-day rolling window.",
      title: "Active users (weekly)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 23750,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "user-wau",
    },
  ],
  [
    "user_mau",
    {
      categories: ["alternative"],
      metric_id: "user_mau",
      definition:
        "number of distinct addresses interacting with business relevant contracts on a monthly basis, based on a 30-day rolling window.",
      title: "Active users (monthly)",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 23875,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "user-mau",
    },
  ],
  [
    "active_developers",
    {
      categories: ["alternative"],
      metric_id: "active_developers",
      definition:
        "number of distinct GitHub users that made 1+ commits to the project’s public GitHub repositories during the past 30 days.",
      title: "Core developers",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 24000,
      trending: true,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "active-developers",
    },
  ],
  [
    "code_commits",
    {
      categories: ["alternative"],
      metric_id: "code_commits",
      definition:
        "number of commits to the project’s public GitHub repositories.",
      title: "Code commits",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: false,
      is_lower_value_better: false,
      index: 25000,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "code-commits",
    },
  ],
  [
    "contract_deployers",
    {
      categories: [],
      metric_id: "contract_deployers",
      definition:
        "number of distinct EOAs initiating transactions where contract creations occur.",
      title: "Contract deployers",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: false,
      is_lower_value_better: false,
      index: 26000,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: false,
      slug: "contract-deployers",
    },
  ],
  [
    "trade_count",
    {
      categories: [],
      metric_id: "trade_count",
      definition:
        "number of successful onchain token trades executed during a selected time period.",
      title: "Trade count",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: false,
      is_lower_value_better: false,
      index: 26250,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "trade-count",
    },
  ],
  [
    "transaction_count",
    {
      categories: ["alternative"],
      metric_id: "transaction_count",
      definition:
        "number of onchain transactions during a selected time period (including unsuccessful transactions).",
      title: "Transaction count",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: false,
      is_lower_value_better: false,
      index: 26500,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "transaction-count",
    },
  ],
  [
    "transactions_per_second",
    {
      categories: ["alternative"],
      metric_id: "transactions_per_second",
      definition: "average number of transactions per second.",
      title: "Transactions per second",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 26550,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "transactions-per-second",
    },
  ],
  [
    "transaction_fee_average",
    {
      categories: ["alternative"],
      metric_id: "transaction_fee_average",
      definition: "average fee per transaction.",
      title: "Average transaction fee",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 26600,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "transaction-fee-average",
    },
  ],
  [
    "afpu",
    {
      categories: ["alternative"],
      metric_id: "afpu",
      definition:
        "average fees per user. It's calculated by dividing the daily fees by the number of daily active users. The definition of 'active user' varies by market sector, and you can find them on the project-specific dashboards.",
      title: "Average fees per user (AFPU)",
      long_title: "Average fees per user (AFPU)",
      short_title: "AFPU",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 26645,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "afpu",
    },
  ],
  [
    "arpu",
    {
      categories: ["alternative"],
      metric_id: "arpu",
      definition:
        "average revenue per user. It's calculated by dividing the daily revenue by the number of daily active users. The definition of 'active user' varies by market sector, and you can find them on the project-specific dashboards.",
      title: "Average revenue per user (ARPU)",
      long_title: "Average revenue per user (ARPU)",
      short_title: "ARPU",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 26646,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "arpu",
    },
  ],
  [
    "message_count",
    {
      categories: ["alternative"],
      metric_id: "message_count",
      definition: "messages sent per day.",
      title: "Message count",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: false,
      is_lower_value_better: false,
      index: 26647,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: false,
      slug: "message-count",
    },
  ],
  [
    "trading_volume_avg_per_trade_count",
    {
      categories: ["alternative"],
      metric_id: "trading_volume_avg_per_trade_count",
      definition:
        "daily average trading volume generated per trade. It's calculated by dividing the daily trading volume by the daily trade count.",
      title: "Average trading volume (per trade)",
      long_title: "Average trading volume (per trade)",
      short_title: "Avg. trading volume (per trade)",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 26675,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "trading-volume-avg-per-trade-count",
    },
  ],
  [
    "trading_volume_avg_per_user",
    {
      categories: ["alternative"],
      metric_id: "trading_volume_avg_per_user",
      definition:
        "daily average trading volume generated per user. It's calculated by dividing the daily trading volume by the number of daily active traders.",
      title: "Average trading volume (per user)",
      long_title: "Average trading volume (per user)",
      short_title: "Avg. trading volume (per user)",
      governance_forum_link: null,
      format: "price",
      static: true,
      is_lower_value_better: false,
      index: 26676,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "trading-volume-avg-per-user",
    },
  ],
  [
    "block_time",
    {
      categories: ["alternative"],
      metric_id: "block_time",
      definition:
        "average time elapsed between the addition of successive blocks to a blockchain.",
      title: "Block time",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "time",
      static: true,
      is_lower_value_better: true,
      index: 26700,
      trending: false,
      table_enabled: true,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: true,
      slug: "block-time",
    },
  ],
  [
    "vesting_schedule",
    {
      categories: [],
      metric_id: "vesting_schedule",
      definition:
        "the number of vested or unlocked tokens, i.e. tokens that can be freely traded on the market.",
      title: "Vesting schedule",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 27000,
      trending: false,
      table_enabled: false,
      chart_enabled: false,
      is_gmv_metric: false,
      sources: "Token Terminal",
      tier: "pro",
      dashboard_enabled: false,
      slug: "vesting-schedule",
    },
  ],
  [
    "message_execution_rate",
    {
      categories: ["alternative"],
      metric_id: "message_execution_rate",
      definition: "message execution rate of the network.",
      title: "Message execution rate",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 40011,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "message-execution-rate",
    },
  ],
  [
    "total_icp_staked_on_nns",
    {
      categories: [],
      metric_id: "total_icp_staked_on_nns",
      definition: "total amount of ICP staked in neurons.",
      title: "Total ICP staked on NNS",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "token",
      static: true,
      is_lower_value_better: false,
      index: 50001,
      trending: false,
      table_enabled: false,
      chart_enabled: false,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "total-icp-staked-on-nns",
    },
  ],
  [
    "number_of_icp_transactions",
    {
      categories: [],
      metric_id: "number_of_icp_transactions",
      definition: "number of ICP transactions.",
      title: "Number of ICP transactions",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: false,
      is_lower_value_better: false,
      index: 500002,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "number-of-icp-transactions",
    },
  ],
  [
    "ckbtc_total_supply",
    {
      categories: [],
      metric_id: "ckbtc_total_supply",
      definition: "ckBTC total supply.",
      title: "ckBTC total supply",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "token_ckBTC",
      static: true,
      is_lower_value_better: false,
      index: 500003,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "ckbtc-total-supply",
    },
  ],
  [
    "total_icp_burned",
    {
      categories: [],
      metric_id: "total_icp_burned",
      definition: "total amount of ICP burned.",
      title: "Total ICP burned",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "token",
      static: true,
      is_lower_value_better: false,
      index: 500004,
      trending: false,
      table_enabled: false,
      chart_enabled: false,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "total-icp-burned",
    },
  ],
  [
    "nns_proposals",
    {
      categories: [],
      metric_id: "nns_proposals",
      definition: "number of governance proposals.",
      title: "NNS proposals",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: false,
      is_lower_value_better: false,
      index: 500005,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "nns-proposals",
    },
  ],
  [
    "total_transaction_fees",
    {
      categories: [],
      metric_id: "total_transaction_fees",
      definition: "total amount of ICP burned through transaction fees.",
      title: "Total transaction fees",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "token",
      static: true,
      is_lower_value_better: false,
      index: 500005,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "total-transaction-fees",
    },
  ],
  [
    "number_of_neurons",
    {
      categories: [],
      metric_id: "number_of_neurons",
      definition: "total number of staking accounts.",
      title: "Number of neurons",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 500006,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "number-of-neurons",
    },
  ],
  [
    "total_internet_identities",
    {
      categories: [],
      metric_id: "total_internet_identities",
      definition: "total number of created internet identities.",
      title: "Total internet identities",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 500009,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "total-internet-identities",
    },
  ],
  [
    "unique_transacting_wallets",
    {
      categories: [],
      metric_id: "unique_transacting_wallets",
      definition:
        "number of distinct wallets making transactions on the network.",
      title: "Unique transacting wallets",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 500010,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "unique-transacting-wallets",
    },
  ],
  [
    "blocks_per_second",
    {
      categories: [],
      metric_id: "blocks_per_second",
      definition: "average number of blocks per second.",
      title: "Blocks per second",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "number",
      static: true,
      is_lower_value_better: false,
      index: 500012,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "blocks-per-second",
    },
  ],
  [
    "cycles_burn_rate",
    {
      categories: [],
      metric_id: "cycles_burn_rate",
      definition: "average number of cycles burned per second.",
      title: "Cycles burn rate",
      long_title: null,
      short_title: null,
      governance_forum_link: null,
      format: "cycles_per_seconds",
      static: true,
      is_lower_value_better: false,
      index: 5000011,
      trending: false,
      table_enabled: false,
      chart_enabled: true,
      is_gmv_metric: false,
      sources: "Internet Computer API",
      tier: "free",
      dashboard_enabled: false,
      slug: "cycles-burn-rate",
    },
  ],
]
export default metricConfiguration
